<template>
  <CRow>
    <CCol col="4" >
      <CCard>   
        <CCardHeader><b>Personal Info</b> </CCardHeader>
        <CListGroup >
          <CListGroupItem href="#"> Name :  {{ data.fullname }} </CListGroupItem>
          <CListGroupItem href="#"> Email :  {{ data.email }} </CListGroupItem>
          <CListGroupItem href="#"> Gender :  {{ data.gender }} </CListGroupItem>
          <!-- <CListGroupItem href="#"> Teacher :  {{ datas.data.teacher_name }} </CListGroupItem> -->
          
        </CListGroup>
      </CCard>
	    <CCard>   
        <CCardHeader><b>Result</b></CCardHeader>
        <CListGroup >
          <CListGroupItem>
            <div v-if="data.total_penyembahan">
              <CRow>
                <CCol class="col-10">Total Penyembahan</CCol>
                <CCol class="col-2">{{ data.total_penyembahan }}</CCol>
              </CRow>
            </div>
            <div v-if="data.total_persekutuan">
              <CRow>
                <CCol class="col-10">Total Persekutuan</CCol>
                <CCol class="col-2">{{ data.total_persekutuan }}</CCol>
              </CRow>
            </div>
            <div v-if="data.total_pemuridan">
              <CRow>
                <CCol class="col-10">Total Pemuridan</CCol>
                <CCol class="col-2">{{ data.total_pemuridan }}</CCol>
              </CRow>
            </div>
            <div v-if="data.total_pelayanan">
              <CRow>
                <CCol class="col-10">Total Pelayanan</CCol>
                <CCol class="col-2">{{ data.total_pelayanan }}</CCol>
              </CRow>
            </div>
            <div v-if="data.total_penginjilan">
              <CRow>
                <CCol class="col-10">Total Penginjilan</CCol>
                <CCol class="col-2">{{ data.total_penginjilan }}</CCol>
              </CRow>
            </div>
            <div v-if="data.total_kesehatanrohani">
              <CRow>
                <CCol class="col-10">Total Kesehatan Rohani</CCol>
                <CCol class="col-2">{{ data.total_kesehatanrohani }}</CCol>
              </CRow>
            </div>
          </CListGroupItem>  
        </CListGroup>
      </CCard>
    </CCol>
    <CCol col="8" >
      <CCard v-if="data.answer_penyembahan">
         <CCardHeader><b>Penyembahan</b></CCardHeader>
          <CCardBody>
            <table class="mt-3">
              <thead>
                <tr >
                  <th>question</th>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                  <th>4</th>
                  <th>5</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i) in data.answer_penyembahan" :key="i.index">
                  <td >{{ question_penyembahan[i.question - 1] }}</td>
                  <td v-if="i.answer == 1">x</td><td v-else></td>
                  <td v-if="i.answer == 2">x</td><td v-else></td>
                  <td v-if="i.answer == 3">x</td><td v-else></td>
                  <td v-if="i.answer == 4">x</td><td v-else></td>
                  <td v-if="i.answer == 5">x</td><td v-else></td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
      </CCard>
      <CCard v-if="data.answer_persekutuan">
         <CCardHeader><b>Persekutuan</b></CCardHeader>
          <CCardBody>
            <table class="mt-3">
              <thead>
                <tr >
                  <th>question</th>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                  <th>4</th>
                  <th>5</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i) in data.answer_persekutuan" :key="i.index">
                  <td >{{ question_persekutuan[i.question - 1] }}</td>
                  <td v-if="i.answer == 1">x</td><td v-else></td>
                  <td v-if="i.answer == 2">x</td><td v-else></td>
                  <td v-if="i.answer == 3">x</td><td v-else></td>
                  <td v-if="i.answer == 4">x</td><td v-else></td>
                  <td v-if="i.answer == 5">x</td><td v-else></td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
        </CCard>
      <CCard v-if="data.answer_pemuridan">
         <CCardHeader><b>Pemuridan</b></CCardHeader>
          <CCardBody>
            <table class="mt-3">
              <thead>
                <tr >
                  <th>question</th>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                  <th>4</th>
                  <th>5</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i) in data.answer_pemuridan" :key="i.index">
                  <td >{{ question_pemuridan[i.question - 1] }}</td>
                  <td v-if="i.answer == 1">x</td><td v-else></td>
                  <td v-if="i.answer == 2">x</td><td v-else></td>
                  <td v-if="i.answer == 3">x</td><td v-else></td>
                  <td v-if="i.answer == 4">x</td><td v-else></td>
                  <td v-if="i.answer == 5">x</td><td v-else></td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
        </CCard>
      <CCard v-if="data.answer_pelayanan">
         <CCardHeader><b>Pelayanan</b></CCardHeader>
          <CCardBody>
            <table class="mt-3">
              <thead>
                <tr >
                  <th>question</th>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                  <th>4</th>
                  <th>5</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i) in data.answer_pelayanan" :key="i.index">
                  <td >{{ question_pelayanan[i.question - 1] }}</td>
                  <td v-if="i.answer == 1">x</td><td v-else></td>
                  <td v-if="i.answer == 2">x</td><td v-else></td>
                  <td v-if="i.answer == 3">x</td><td v-else></td>
                  <td v-if="i.answer == 4">x</td><td v-else></td>
                  <td v-if="i.answer == 5">x</td><td v-else></td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
        </CCard>
      <CCard v-if="data.answer_penginjilan">
         <CCardHeader><b>Penginjilan</b></CCardHeader>
          <CCardBody>
            <table class="mt-3">
              <thead>
                <tr >
                  <th>question</th>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                  <th>4</th>
                  <th>5</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i) in data.answer_penginjilan" :key="i.index">
                  <td >{{ question_penginjilan[i.question - 1] }}</td>
                  <td v-if="i.answer == 1">x</td><td v-else></td>
                  <td v-if="i.answer == 2">x</td><td v-else></td>
                  <td v-if="i.answer == 3">x</td><td v-else></td>
                  <td v-if="i.answer == 4">x</td><td v-else></td>
                  <td v-if="i.answer == 5">x</td><td v-else></td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
        </CCard>
      <CCard v-if="data.answer_kesehatanrohani">
         <CCardHeader><b>Kesehatan Rohani</b></CCardHeader>
          <CCardBody>
            <table class="mt-3">
              <thead>
                <tr >
                  <th>question</th>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                  <th>4</th>
                  <th>5</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i) in data.answer_kesehatanrohani" :key="i.index">
                  <td >{{ question_kesehatanrohani[i.question - 1] }}</td>
                  <td v-if="i.answer == 1">x</td><td v-else></td>
                  <td v-if="i.answer == 2">x</td><td v-else></td>
                  <td v-if="i.answer == 3">x</td><td v-else></td>
                  <td v-if="i.answer == 4">x</td><td v-else></td>
                  <td v-if="i.answer == 5">x</td><td v-else></td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
        </CCard>
    </CCol>

    <!-- <pre>{{ $data | json }}</pre> -->
    <alertmodal></alertmodal>
  </CRow>

</template>

<script>  
import moment from 'moment';
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';

import onlineclass from '@/services/onlineclass';

import axios from 'axios'

import store from '@/store.js'

export default {
name: 'detailmodal',
components: {  alertmodal },
  data () {
    return {
      data:[],
      question_penyembahan:[
        "Cara hidup saya menunjukkan bahwa Allah merupakan prioritas tertinggi saya",
        "Saya bergantung pada Allah dalam setiap aspek kehidupan saya",
        "Tidak ada apa pun dalam hidup saya yang tidak saya serahkan / pertahankan dari Allah",
        "Saya merenungkan Firman Tuhan secara teratur dan menyertakan Tuhan dalam kegiatan hidup sehari - hari",
        "Saya memiliki hasrat yang kuat untuk menikmati waktu bersama Allah",
        "Saya adalah pribadi yang sama, baik ketika dilihat maupun tidak dilihat orang",
        "Saya memiliki rasa takjub akan kebesaran Tuhan sekalipun ketika saya tidak merasakan kehadiran-Nya",
      ],
      question_persekutuan:[
        "Saya sangat terbuka dan jujur mengenai diri saya",
        "Saya menggunakan waktu dan sumber daya secara teratur untuk memperhatikan kebutuhan orang lain",
        "Saya memiliki hubungan yang mendalam dan bermakna denga orang-orang di gereja",
        "Saya mudah menerima nasihat, dorongan, dan koreksi dari orang lain",
        "Saya bertemu secara teratur dengan sekelompok orang Kristen untuk bersekutu dan akuntabilitas",
        "Tidak ada relasi saya yang tidak beres saat ini",
        "Tidak ada tindakan atau perkataan saya mengenai orang lain yang tidak bersedia saya ungkapkan kepada yang bersangkutan secara pribadi",
      ],
      question_pemuridan:[
        "Saya cepat mengakui karakter saya yang tidak seperti Kristus",
        "Cara saya menggunakan uang menunjukkan bahwa saya lebih mementingkan Allah dan orang lain daripada diri saya sendiri",
        "Saya mengizinkan Firman Tuhan menuntun pikiran saya dan mengubah tindakan saya",
        "Saya dapat memuji Tuhan pada masa sulit dan memandangnya sebagai kesempatan untuk bertumbuh",
        "Saya mendapati diri saya membuat pilihan-pilihan yang lebih baik untuk melakukan yang benara ketika saya dicobai untuk melakukan yang salah",
        "Saya mendapati bahwa doa mengubah cara saya memandang dan berinteraksi dengan dunia",
        "Saya konsisten dalam melakukan kebiasaan-kebiasaan yang menolong saya makin menjadi seperti Yesus",
      ],
      question_pelayanan:[
        "Saya menggunakan waktu secara teratur untuk melayani Tuhan",
        "Saya sedang melayani Tuhan dengan karunia-karunia dan keterbebanan yang Dia berikan pada saya",
        "Saya selalu memikirkan bagaimana hidup saya bisa memberi dampak bagi kerajaan Allah",
        "Saya sering memikirkan cara-cara menggunakan berbagai karunia dan kemampuan yang diberikan Allah untuk menyukakan hati Allah",
        "Saya senang memenuhi kebutuhan orang lain tanpa mengharapkan imbalan",
        "Orang-orang terdekat saya akan berkata bahwa hidup saya merupakan gambaran yang lebih banyak memberi daripada menerima",
        "Saya memandang pengalaman menyakitkan sebagai kesempatan untuk melayani orang lain",
      ],
      question_penginjilan:[
        "Saya merasa punya tanggung jawab pribadi untuk membagikan iman kepada orang-orang yang belum mengenal Yesus",
        "Saya mencari berbagai kesempatan untuk membangun relasi dengan orang-orang yang belum mengenal Yesus",
        "Saya berdoa secara teratur untuk orang-orang yang belum mengenal Kristus",
        "Saya percaya diri dengan kemampuan saya membagikan iman",
        "Hati saya sangat terbeban untuk menyampaikan Kabar Baik berita Injil kepada orang-orang yang belum pernah mendengarnya",
        "Saya mendapati bahwa relasi saya dengan Yesus sering muncul dalam percakapan saya dengan orang-orang yang belum mengenal-Nya",
        "Saya terbuka untuk pergi ke mana pun Tuhan memanggil saya, dalam kapasitas apa pun, untuk membagikan iman saya",
      ],
      question_kesehatanrohani:[
        "Cara hidup saya menunjukkan bahwa Tuhan adalah prioritas tertinggi saya",
        "Saya bergantung penuh kepada Tuhan dalam setiap aspek kehdiupan saya",
        "Tidak ada apa pun dalam hidup saya yang tidak saya serahkan kepada Tuhan",
        "Saya membaca dan merenungkan Firman Tuhan secara teratur dan menyertakan Tuhan dalam kegiatan hidup saya sehari-hari",
        "Saya sangat menikmati kebersamaan saya dengan Tuhan dalam waktu-waktu teduh saya",
        "Saya adalah pribadi yang sama, baik ketika dilihat maupun tidak dilihat orang",
        "Saya memiliki rasa takjub sekalipun ketika saya tidak merasakan kehadiranNya",
        "Saya sangat terbuka dan jujur mengenai diri saya",
        "Saya menggunakan waktu dan tenaga saya untuk memperhatikan kebutuhan orang lain",
        "Saya memiliki hubungan yang baik dan bermakna dengan orang-orang di gereja",
        "Saya mudah menerima nasihat, dorongan dan koreksi dari orang lain",
        "Saya bertemu secara teratur dengan sekelompok orang Kristen untuk bersekutu",
        "Hubungan saya baik dengan keluarga, teman-teman dan dipekerjaan saat ini sangat baik",
        "Saya sangat terbuka dan jujur",
        "Saya dengan cepat menyadari bahwa karakter saya tidak seperti Kristus",
        "Cara saya menggunakan uang menunjukkan bahwa saya lebih mementingkan Tuhan",
        "Saya mengijinkan Firman Tuhan menuntun pikiran saya dan mengubah tindakan saya",
        "Saya dapat memuji Tuhan pada masa sulit dan memandangnya sebagai kesempatan untuk bertumbuh",
        "Dalam situasi yang sulit, saya mendapati diri saya dapat membuat keputusan yang baik dan benar",
        "Saya mendapati bahwa doa mengubah cara saya memandang dan berinteraksi dengan dunia",
        "Saya konsisten dalam mentaati kebenaran Firman Tuhan",
        "Saya memiliki waktu yang memang saya dedikasikan untuk melayani Tuhan",
        "Saya memahami karunia-karunia yang Tuhan berikan kepada saya dan dengan senang hati menggunakan nya dalam pelayanan saya",
        "Saya selalu memikirkan bagaimana hidup saya bisa memberi dampak bagi kerajaan Allah",
        "Saya sering memikirkan cara-cara menggunakan berbagai karunia dan kemampuan yang diberikan Tuhan untuk menyenangkan Dia",
        "Saya senang memenuhi kebutuhan orang lain tanpa mengharapkan imbalan",
        "Orang-orang terdekat saya akan berkata bahwa hidup saya lebih banyak memberi daripada menerima",
        "Saya memandang pengalaman menyakitkan sebagai kesempatan untuk melayani orang lain",
        "Saya merasa punya tanggungjawab pribadi untuk menyampaikan kabar baik kepada orang lain",
        "Saya mencari berbagai kesempatan untuk membangun hubungan dg orang-orang yang belum percaya kepada Kristus",
        "Saya berdoa secara teratur untuk orang-orang yang belum mengenal Kristus",
        "Saya percaya diri dengan kemampuan saya memberitakan injil",
        "Hati saya sangat terbeban untuk menyampaikan kabar baik kepada orang-orang yang belum pernah mendengarnya",
        "Saya mendapati bahwa hubungan saya dg Kristus sering muncul dalam percakapan-percakapan dg orang yang belum mengenalNya",
        "Saya terbuka untuk pergi ke mana pun Tuhan memanggil saya khususnya dalam mengabarkan Injil",
      ],
    }
  },
  mounted(){
    this.load()
    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.load();
          console.log('load mounted')  
      }
    });
  },  
  
  beforeDestroy(){
    EventBus.$off('TABLE_UPDATE', this.listener)  
    //console.log('OFF_OPEN_MODAL_IKID')
   },

 methods:{
    load(){
        onlineclass.getKesehatanRohanibyID(this.$route.query.id)
        .then(res => {
            this.data = res.data;
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },
  }  
}

</script>
